/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
export var AvatarSizes;
(function (AvatarSizes) {
    AvatarSizes["Size50"] = "50";
    AvatarSizes["Size100"] = "100";
    AvatarSizes["Size115"] = "115";
    AvatarSizes["Size230"] = "230";
    AvatarSizes["Size138"] = "138";
    AvatarSizes["Size276"] = "276";
})(AvatarSizes || (AvatarSizes = {}));
